import { Component, OnInit, ViewChild } from '@angular/core';
import { ReservationService } from 'src/app/shared/services/rest/reservation.service';
import { Occupancy } from 'src/app/shared/models/occupancy';
import { Reservation } from 'src/app/shared/models/reservation';
import { ModalDialogComponent } from 'src/app/shared/components/modal-dialog/modal-dialog.component';
import { StatusId } from 'src/app/shared/models/status-id';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ICreateReservationParams } from '../create-reservation-dialog/create-reservation-dialog-base.component';
import { ResourceType } from 'src/app/shared/models/resource-type';

@Component({
  selector: 'app-my-reservation',
  templateUrl: './my-reservation.component.html',
  styleUrls: ['./my-reservation.component.scss']
})
export class MyReservationComponent implements OnInit {

  @ViewChild('editRoomReservationDialog') private editRoomReservationDialog: ModalDialogComponent;

  @ViewChild('editDeviceReservationDialog') private editDeviceReservationDialog: ModalDialogComponent;

  @ViewChild('roomInfoDialog') private modalRoomInfo: ModalDialogComponent;

  @ViewChild('deviceInfoDialog') private modalDeviceInfo: ModalDialogComponent;

  @ViewChild('confirmReservationDialog') private confirmReservationDialog: ModalDialogComponent;

  /**
   * Currently selected room
   *
   * @type {number}
   * @memberof RoomAllocationTableComponent
   */
  activeItemId: number;

  data: IDisplayData[] = [];

  isLoading = true;

  createReservationParams: ICreateReservationParams;

  confirmReservationId: number;

  constructor(private reservationService: ReservationService, private router: Router, private route: ActivatedRoute) { }

  get hasData(): boolean {
    return this.data.length > 0;
  }

  ngOnInit() {
    this.loadData();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.confirmRouteAction();
      }
    });

    this.confirmRouteAction();
  }

  confirmRouteAction() {
    if (this.route.firstChild) {
      const id = this.route.firstChild.snapshot.paramMap.get('id');
      this.confirmReservationId = Number(id);
      setTimeout(() => { this.confirmReservationDialog.openModal(); }, 50);
    } else {
      this.confirmReservationDialog.closeModal('cancel');
    }
  }

  /**
   * Handle click on edit reservation
   *
   * @param {MouseEvent} event
   * @memberof MyReservationComponent
   */
  onClickEdit(idReservation: number) {
    const element = this.data.find(item => item.Id === idReservation);
    this.createReservationParams = {
      idReservation: idReservation,
      idRessource: element.Occupancy.ResourceId,
      from: element.Occupancy.DateTimeFrom,
      to: element.Occupancy.DateTimeTo
    };

    switch (element.Occupancy.ResourceTypeId) {
      case ResourceType.Raum:
        this.editRoomReservationDialog.openModal();
        break;
      case ResourceType.Gerät:
        this.editDeviceReservationDialog.openModal();
        break;
      default:
        throw Error(`Ressourec of type "${element.Occupancy.ResourceTypeId}" not implemented`);
    }
  }

  /**
  * Handel openRoomInfo callback of room-allocation-item
  *
  * @param {number} reservationId
  * @memberof RoomAllocationComponent
  */
  onOpenRoomInfo(reservationId: number, event: MouseEvent) {
    event.preventDefault();
    const element = this.data.find(item => item.Id === reservationId);
    this.activeItemId = element.Occupancy.ResourceId;

    switch (element.Occupancy.ResourceTypeId) {
      case ResourceType.Raum:
        this.modalRoomInfo.openModal();
        break;
      case ResourceType.Gerät:
        this.modalDeviceInfo.openModal();
        break;
      default:
        throw Error(`Ressourec of type "${element.Occupancy.ResourceTypeId}" not implemented`);
    }
  }

  onReservationCanceld() {
    this.loadData();
    this.editRoomReservationDialog.closeModal('cancel');
    this.editDeviceReservationDialog.closeModal('cancel');
  }

  onReservationSaved() {
    this.loadData();
  }

  /**
   * Redirect to my reservations on close of popup
   *
   * @memberof MyReservationComponent
   */
  onCloseConfirmation(data: any) {
    this.router.navigate(['/my']);
  }

  private loadData() {
    this.reservationService.getMyCurrent().toPromise()
      .then(
        (data: Reservation[]) => {
          const elements: Array<IDisplayData> = [];
          // a bit strange - sometimes data is the body, sometimes it's HttpResponse
          const body = (data instanceof HttpResponse) ? (<HttpResponse<Reservation[]>>data).body : data;
          body.forEach((r: Reservation) => {
            r.Occupancies.forEach((o: Occupancy) => {
              elements.push({
                Id: r.ReservationId,
                Occupancy: Occupancy.create(o),
                Status: r.Status,
                Designation: r.Designation,
                IsCanceld: r.StatusId === StatusId.rStorniert
              });
            });

          });

          this.data = elements.sortByProp(x => x.Occupancy.DateTimeFrom);
          this.isLoading = false;
        },
        (error: HttpErrorResponse) => {
          console.error(error);
          this.isLoading = false;
        });
  }

}

interface IDisplayData {
  Id: number;
  Occupancy: Occupancy;
  Designation: string;
  Status: string;
  IsCanceld: boolean;
}
